export enum ScreenToShowState {
  INITIAL = 'initial',
  WELCOME = 'welcome',
  NEW_CUSTOMER = 'newCustomer',
  LOGGED_IN = 'logged-in',
}
